import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import Toggle from 'react-toggle';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import NumberInput from 'app/components/UI/NumberInput';
import Button from 'app/components/button';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useCreateUser from './useCreateUser';

const CreateUser = () => {
  const {
    userId,
    setChange,
    handleChange,
    values,
    error,
    handleCreateBill,
    pageLoading,
    navigate,
    editted,
  } = useCreateUser();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={userId ? `Edit User` : `Create User`}
          goTo={APP_CONSTANTS.USERS}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-50'>
            <NewInput
              label='Name*'
              id='name'
              type='text'
              placeholder='Enter Name'
              name='name'
              value={values?.name}
              onChange={handleChange}
              errorText={error?.name}
            />
          </div>

          <div className='wd-50'>
            <NumberInput
              label='Contact details*'
              id='phone'
              placeholder='Contact Number'
              name='phone'
              value={values.phone}
              errorText={error?.phone}
              onChange={handleChange}
            />
          </div>

          <div className='wd-50'>
            <NewInput
              label='Email*'
              id='email'
              type='text'
              placeholder='Email'
              name='email'
              value={values?.email}
              onChange={handleChange}
              errorText={error?.email}
            />
          </div>
          <div className='d-block wd-100'>
            <label className='me-2 d-inline-block tooltip-on-hover'>
              Status*
            </label>
            <label className='d-inline-block mt-2'>
              <div className='d-inline-flex align-items-center'>
                <div className='d-inline-flex text-danger'>OFF</div>
                <div className='d-inline-flex mx-2'>
                  <Toggle
                    checked={values.status}
                    icons={false}
                    onChange={() => setChange('status', !values.status)}
                  />
                </div>
                <div className='d-inline-flex text-green'>ON</div>
              </div>
            </label>
          </div>
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateBill}
            variant='Save'
            name={!editted && userId ? 'Next' : userId ? 'Update' : 'Submit'}
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateUser;
